export default __webpack_public_path__ + "static/media/4.ca886c08.svg";